// SeamlessIntegrations.jsx
import styles from "./SeamlessIntegrations.module.css";

const integrations = [
    { name: "Salesforce", letter: "S", bg: "#3b82f6" },
    { name: "HubSpot", letter: "H", bg: "#f97316" },
    { name: "Zendesk", letter: "Z", bg: "#22c55e" },
    { name: "Zoho", letter: "Z", bg: "#ef4444" },
    { name: "WhatsApp", letter: "W", bg: "#22c55e" },
    { name: "Google Sheets", letter: "G", bg: "#10b981" },
    { name: "Slack", letter: "S", bg: "#a855f7" },
    { name: "Zapier", letter: "Z", bg: "#f97316" },
];

const steps = [
    {
        step: "STEP 01",
        title: "Connect & Configure",
        desc: "Integrate with your telephony provider and CRM. Define call flows, scripts, and compliance rules.",
    },
    {
        step: "STEP 02",
        title: "Train & Test",
        desc: "Train agents on your knowledge base. Test with real scenarios and fine-tune responses.",
    },
    {
        step: "STEP 03",
        title: "Launch & Scale",
        desc: "Go live with voice agents. Handle thousands of calls while AI continuously improves.",
    },
];

export default function SeamlessIntegrations() {
    return (
        <div className={styles.wrapper}>
            {/* Integrations Section */}
            <section className={styles.section}>
                <h2 className={styles.title}>Seamless Integrations</h2>
                <p className={styles.subtitle}>
                    Connect with your telephony, CRM, and business tools in minutes.
                </p>

                <div className={styles.grid}>
                    {integrations.map((item) => (
                        <div key={item.name} className={styles.card}>
                            <div
                                className={styles.icon}
                                style={{ background: item.bg }}
                            >
                                {item.letter}
                            </div>
                            <span className={styles.cardLabel}>{item.name}</span>
                        </div>
                    ))}
                </div>
            </section>

            {/* Steps Section */}
            <section className={`${styles.section} ${styles.stepsSection}`}>
                <h2 className={styles.title}>Go Live in Weeks, Not Months</h2>
                <p className={styles.subtitle}>
                    Our team helps you deploy voice AI agents tailored to your business.
                </p>

                <div className={styles.stepsGrid}>
                    {steps.map((s) => (
                        <div key={s.step} className={styles.stepCard}>
                            <span className={styles.stepBadge}>{s.step}</span>
                            <h3>{s.title}</h3>
                            <p>{s.desc}</p>
                        </div>
                    ))}
                </div>
            </section>
        </div>
    );
}
